import { render, staticRenderFns } from "./spectrum-wheel.vue?vue&type=template&id=e53ecdea"
import script from "./spectrum-wheel.vue?vue&type=script&lang=js"
export * from "./spectrum-wheel.vue?vue&type=script&lang=js"
import style0 from "./spectrum-wheel.vue?vue&type=style&index=0&id=e53ecdea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports